import {
  ArrowRight, Check, Wine, Pill, Zap, Tablets, Leaf, Sparkle, Cigarette, Dices, EyeOff, Gamepad2,
} from 'lucide-react'
import { useAssessment } from '../../context/AssessmentContext'
import Shell from '../ui/Shell'
import { pulse } from '../ui/LightField'
import { AREAS, AREA_GROUPS, HEADERS } from '../../data/onboarding'
import { getProgress, STEP_LABEL } from '../../lib/flow'

const ICONS = { Wine, Pill, Zap, Tablets, Leaf, Sparkle, Cigarette, Dices, EyeOff, Gamepad2 }

function AddictionSelection() {
  const { state, dispatch } = useAssessment()
  const count = state.selectedAddictions.length

  const toggle = (slug, el) => {
    if (!state.selectedAddictions.includes(slug) && el) {
      const r = el.getBoundingClientRect()
      pulse(0.6, { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + r.height / 2) / window.innerHeight })
    }
    dispatch({ type: 'TOGGLE_AREA', payload: slug })
  }

  const next = () => {
    if (count === 0) return
    dispatch({ type: 'SET_AREA_INDEX', payload: 0 })
    dispatch({ type: 'SET_SCREEN', payload: 'recoveryGate' })
  }

  return (
    <Shell
      label={STEP_LABEL.addictionSelection}
      progress={getProgress(state)}
      onBack={() => dispatch({ type: 'SET_SCREEN', payload: 'ageCollection' })}
    >
      <main className="flow">
        <div className="flow__head">
          <h1>{HEADERS.areas}</h1>
          <p className="flow__lede">Pick everything that applies.</p>
        </div>

        {AREA_GROUPS.map((group) => (
          <div key={group.id} className="area-group">
            <p className="area-group__label">{group.label}</p>
            <div className="rows rows--2col" role="group" aria-label={group.label}>
              {AREAS.filter((a) => a.group === group.id).map((a) => {
                const Icon = ICONS[a.icon]
                const on = state.selectedAddictions.includes(a.slug)
                return (
                  <button
                    key={a.slug}
                    type="button"
                    role="checkbox"
                    aria-checked={on}
                    className="row row--icon"
                    onClick={(e) => toggle(a.slug, e.currentTarget)}
                  >
                    <span className="row__icon">{Icon && <Icon size={18} strokeWidth={2} />}</span>
                    <span className="row__text">
                      <span className="row__title">{a.label}</span>
                      <span className="row__sub">{a.hint}</span>
                    </span>
                    <span className="row__check" aria-hidden="true"><Check size={14} strokeWidth={3} /></span>
                  </button>
                )
              })}
            </div>
          </div>
        ))}

        <div className="flow__actions">
          <button type="button" className="btn btn--block" onClick={next} disabled={count === 0}>
            {count === 0 ? 'Pick at least one' : `Continue with ${count}`}
            {count > 0 && <ArrowRight size={18} strokeWidth={2.25} />}
          </button>
        </div>
      </main>
    </Shell>
  )
}

export default AddictionSelection
